import React from 'react'
import Link from 'next/link'
import cn from 'classnames'
import styles from './Intro.module.sass'
import Image from '../../Image'
import ScrollParallax from '../../ScrollParallax'

export const Intro = () => {
  const launchChat = () => {
    // @ts-ignore
    // window.$crisp.push(['do', 'chat:open'])
    // window.$crisp.push(['do', 'message:send', ['text', "Hi! I'd like become a Guardian"]])
  }

  return (
    <>
      <a id="next" />
      <div className={styles.intro}>
        <ScrollParallax className={cn('container', styles.container)} animateIn="fadeIn">
          <div className={styles.wrap}>
            <h2 className={cn('h1', styles.title)}>Who are the Guardians?</h2>
            <div className={styles.text}>
              <p>
                Guardians are high-performing software engineers ready to commit to helping
                developers working at leading companies.
              </p>
              <p>The Guardians are matched with teams that need technical guidance.</p>
              <p>
                They earn money and provide advice through 1:1 call, chat in real-time or
                asynchronous messages.
              </p>
            </div>
            <div className={styles.btns}>
              <Link href="/api/auth/signin?callbackUrl=/app/onboarding">
                <a className={cn('button', styles.button)}>I'm ready to earn</a>
              </Link>
            </div>
          </div>
        </ScrollParallax>
        <div className={styles.gallery}>
          <div className={styles.preview}>
            <ScrollParallax animateIn="fadeInUp" delay={200}>
              <Image
                srcSet="img/whats-a-guardian@2x.png 2x"
                src="img/whats-a-guardian@1.5x.png"
                alt="Jungle Program Platform Preview"
              />
            </ScrollParallax>
          </div>
        </div>
      </div>
    </>
  )
}

export default Intro
